
import helper from "@/helpers/helpers"
const default_dev = {
	key 		: 'all',
	deviceId 	: 'all',
	name 		: 'all'
}
export const Devices = {
	namespaced 	: true,
	state 		: {

		devices:  [
			// {...default_dev},
		],
		states : [],
	},
	
	getters 	: {
		list : (state)=> {
			// state.devices.shift();
  			return state.devices;
  		},
  		states:(state)=>{ return state.states },
		list_options : (state)=> {
			let list_temp = [ ...state.devices ];
			list_temp.unshift({...default_dev});

  			return list_temp;
  		},
  		list_options_simple : (state) =>{
  			const temp = state.devices.map(x => {
  				return {
  					id 			: x.id,
  					name 		: x.name,
  					deviceId 	: x.deviceId,
  					manager_id  : x.manager_id,
  				}
  			})
			temp.unshift({...default_dev});
			/*let is_ = true
			temp.forEach(it => {
				if (is_) {

					it.manager_id = 'test'  
				} 
				is_ = !is_
			})*/
			
  			return temp;
  		}
	},
	
	actions 	: {
		get_devices( { commit , dispatch, state} , opts = {opt : 'get', page : 1}){
			// console.log("*************************** commit ", opts)
			return helper.get("/api/v1/device/?page=" + opts.page , "get").then(res => {
				// console.log("restreq request", res);
				if (res && res.data && res.data.rows && res.data.rows.length > 0) {
					if (opts.opt == 'get') {
						commit('concat_devices', res.data.rows);
					}else{
						commit('clean_devices');
						commit('concat_devices',res.data.rows)
						opts.opt = 'get';
					}
					
					
					/*items.forEach((dev,idx_dev)=>{
						if (dev) {
							console.log("test devices ---- ", wrk)
							commit('add_device', dev);
						}
					})*/
				}
				if (res.data.pages > opts.page) {
					opts.page ++;
					dispatch('get_devices', opts)
				}else{
					return Promise.resolve(state.devices)
				}
				
				
			}).catch(er =>{
				console.log("error req devices", er);
				return Promise.resolve(null);


			})
		},
		set_items({commit, dispatch}, opt){
			commit("set_item", opt);
		}, // set item

		update_item({commit, dispatch}, opt){
			if (opt && opt.key == 'devices') {
				commit("update_item_device", opt);
			}
		}
		
	},
	mutations 	: {
		concat_devices(state, items){
			state.devices = state.devices.concat(items);
			/*state.states = state.states.concat(items.map(x=>{ 
				return{					
					deviceId : x.deviceId,
					manager_id : x.manager_id,
					type : x.type,
					name : x.name,		
					state : 2,			
				}
			})); */
			helper.set_local("list_devices", state.devices);
			if (state && state.Format) {
				state.Format.update_list("devices", state.devices);
			}
		},
		
		clean_devices(state){
			state.devices = [];
			// state.devices.push({...default_dev});
		},
		
		update(state, item){
			if (state.devices && state.devices.length > 0) {
				let idx = state.devices.findIndex(x => (x && x.deviceId == item.deviceId))
				if (idx >= 0) {
					state.devices[idx] = { ...item };
					helper.set_local("list_devices", state.devices);
					if (state && state.Format) {
						state.Format.update_list("devices", state.devices);
					}
				}
			}
		},

		delete_device(state, item){
			if (state.devices && state.devices.length > 0) {
				let idx = state.devices.findIndex(x => (x && x.deviceId == item.deviceId))
				if (idx >= 0) {
					state.devices.splice(idx, 1);
					helper.set_local("list_devices", state.devices);
					if (state && state.Format) {
						state.Format.update_list("devices", state.devices);
					}
				}
			}
		},
		set_item(state, item){
			if (item && item.key) {
				state[item.key] = item.item;
				// console.log("state **********************", state[item.key])
			}
		},

		update_item_device(state, item){
			
			if (item && item.index) {
				state.devices[index] = {...item.info};
			}
		},
		updateState(state, item){
			if (item) {
				const idx = state.states.findIndex(x => x && item.deviceId == x.deviceId)
				if (idx >= 0) {
					state.states[idx] = { ...state.states[idx], ...item };
				}
			}
		}
	},
}